import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import AuthSettingsItemHeader from '../../components/common/AuthSettingsItemHeader';
import { DashboardButton } from '../../components/common/Button';
import { InputWord } from '../../components/common/Input';
import { ToastQueueRefContext } from '../../components/common/Toast';
import { nicknameSchema, nicknameType } from '../../schema/DashboardSchema';
import UsersService from '../../services/users.service';

const DashboardAuthenticationNickNameComponent = () => {
  const navigate = useNavigate();
  const usersService = new UsersService();
  const toastQueueRef = useContext(ToastQueueRefContext);
  const { logout } = useAuth();

  const nicknameMethods = useForm<nicknameType>({
    resolver: yupResolver(nicknameSchema),
    mode: 'onSubmit',
    defaultValues: {
      nickname: '',
    },
  });

  const updateNickname = async ({ nickname }: nicknameType) => {
    await usersService.updateNickname({
      nickName: nickname,
    });

    toastQueueRef?.current?.addToast({
      type: 'SUCCESS',
      description: 'Identifiant mise à jour',
      timer: 5000,
    });

    logout();
    navigate('/login', { replace: true });
  };

  return (
    <>
      <AuthSettingsItemHeader
        title='Modifier votre identifiant'
        description='Nous vous recommandons de choisir un identifiant personnel ne pouvant pas être deviné : évitez « nom.prénom »'
      />
      <FormProvider {...nicknameMethods}>
        <form onSubmit={nicknameMethods.handleSubmit(updateNickname)}>
          <div className='w-1/2 max-md:w-full'>
            <Controller
              name='nickname'
              control={nicknameMethods.control}
              render={({ field: { onChange, value }, fieldState: { error } }) => (
                <>
                  <InputWord
                    label='Identifiant'
                    type='text'
                    placeholder='ex : SocrateHelenien8'
                    value={value}
                    onChangeValue={(value: string) => onChange(value.toLowerCase())}
                    errorMessage={error?.message}
                  />
                </>
              )}
            />
          </div>
          <div className='mt-6 flex justify-end'>
            <DashboardButton type='cancel' onClick={() => navigate('/dashboard/authentication')} />
            <DashboardButton type='confirm' />
          </div>
        </form>
      </FormProvider>
    </>
  );
};

export default DashboardAuthenticationNickNameComponent;
